import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import LoadingSpinner from "./shared/LoadingSpinner";
import BackendOutageCard from "./BackendOutageCard";

const getCachedAuthToken = () => {
  try {
    return localStorage.getItem('authToken');
  } catch {
    return null;
  }
};

const RequireAuth = ({ children }) => {
  const { user, isInitializing, backendDown } = useContext(AuthContext);
  const location = useLocation();
  const cachedAuthToken = getCachedAuthToken();

  if (isInitializing) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-primary, #0f172a)',
        zIndex: 2000
      }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!user?.token && !cachedAuthToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (backendDown && (user?.token || cachedAuthToken)) {
    return <BackendOutageCard />;
  }

  if (!user?.token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth; 